export default "__VITE_ASSET__BALdxEr9__"